import { Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { FormControl, ValidationErrors } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FormsValidationErrorsTextService } from '@core/services/forms-validation-errors-text.service';

@Directive({
	selector: '[cassErrorForFormControl]'
})
export class ErrorForFormControlDirective implements OnDestroy {

	formControl?: FormControl;
	subscription$?: Subscription;

	@Input()
	set cassErrorForFormControl(value: FormControl) {
		this.formControl = value;
		this.subscription$ = value.statusChanges.subscribe(() => {
			this.updateErrorMessage();
		});
		this.updateErrorMessage(); // first event is missed, so need to explicitly update here
	}

	constructor(private elemRef: ElementRef, private validationErrorsTextService: FormsValidationErrorsTextService) { }

	ngOnDestroy(): void {
		this.subscription$?.unsubscribe();
	}

	async updateErrorMessage() {
		if (this.formControl) {
			this.elemRef.nativeElement.innerHTML = this.formControl.valid ? '' : await this.validationErrorsTextService.getText(this.formControl.errors);
		}
	}
}


